import React, { useState, useEffect, useRef } from 'react';
import { useCookies } from 'react-cookie';
import { Accordion } from 'react-bootstrap';

//D2L Web Components
import '@brightspace-ui/labs/components/navigation/navigation.js';
import '@brightspace-ui/labs/components/navigation/navigation-button-icon.js';
import '@brightspace-ui/labs/components/navigation/navigation-main-header.js';
import '@brightspace-ui/labs/components/navigation/navigation-main-footer.js';
import '@brightspace-ui/labs/components/navigation/navigation-dropdown-button-icon.js';
import '@brightspace-ui/core/components/button/button.js';
import '@brightspace-ui/core/components/dialog/dialog.js';
import '@brightspace-ui/core/components/switch/switch.js';
import '@brightspace-ui/core/components/dropdown/dropdown.js';
import '@brightspace-ui/core/components/dropdown/dropdown-content.js';


var env;

if (JSON.stringify(process.env.REACT_APP_ENV) === JSON.stringify("development")) {
  env = 'dev';
}
else {
  env = 'prod';
}
var westdistribution = 'https://d1cxwt39sm8ti5.cloudfront.net'

export default function H5PServices() {
  //hardcoded values
  const green = '#46a661';
  const red = '#ff0008ff';
  const orange = '#fc7500ff';
  const updateInterval = 60000;

  //main data
  const [serviceStatusData, setServiceStatusData] = useState(false);
  const [incidentHistory, setIncidentHistory] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [dateStamp, setDateStamp] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [jsonLoaded, setJsonLoaded] = useState(false);
  const [fetchError, setFetchError] = useState(false);
  const [statusFetchFailed, setStatusFetchFailed] = useState(false);
  const [historyFetchFailed, setHistoryFetchFailed] = useState(false);
  const [timestampFetchFailed, setTimestampFetchFailed] = useState(false);


  //Settings related
  const [darkMode, setDarkMode] = useState([]);
  const darkModeSwitch = useRef({});
  const [autoRefresh, setAutoRefresh] = useState([]);
  const autoRefreshSwitch = useRef({});
  const [cookies, setCookie] = useCookies(['statusPageUser']);

  //Error messages
  const helpDialog = useRef(false);

  const nav = useRef({});
  const fetchInterval = useRef({});
  const accordions = useRef({});
  const accordionitem = useRef({});

  var fetchHeaders = new Headers();
  fetchHeaders.append('pragma', 'no-cache');
  fetchHeaders.append('cache-control', 'no-cache');

  var fetchReq = {
    method: 'GET',
    headers: fetchHeaders,
  };
  async function fetchWithRetry(url, options, retries = 3, delay = 1000) {
    for (let i = 0; i < retries; i++) {
      try {
        const response = await fetch(url, options);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response;
      } catch (error) {
        console.log(`Fetch attempt ${i + 1} failed for ${url}:`, error.message);

        if (i === retries - 1) {
          // Last retry failed
          throw new Error(`Failed to fetch after ${retries} attempts: ${error.message}`);
        }

        // Wait before retrying (exponential backoff)
        await new Promise(resolve => setTimeout(resolve, delay * Math.pow(2, i)));
      }
    }
  }

  async function fetchH5PStatusJSON(env, distribution) {
    try {
      const response = await fetchWithRetry(
        distribution + '/' + env + '/h5p/h5p_status.json',
        fetchReq,
        3,
        1000
      );
      const data = await response.json();
      setServiceStatusData(loadStatusData(data));
      setFetchError(false);
      setStatusFetchFailed(false);
    } catch (error) {
      console.error('Error fetching H5P status:', error);
      if (!serviceStatusData) {
        setFetchError(true);
      } else {
        // We have old data, just show a warning banner
        setStatusFetchFailed(true);
      }
    }
  }

  async function fetchH5PHistoryJSON(env, distribution) {
    try {
      const response = await fetchWithRetry(
        distribution + '/' + env + '/h5p/h5p_incidents.json',
        fetchReq,
        3,
        1000
      );
      const data = await response.json();
      setIncidentHistory(generateH5PHistory(data));
      setJsonLoaded(true);
      setHistoryFetchFailed(false);
    } catch (error) {
      console.error('Error fetching H5P incident history:', error);
      setHistoryFetchFailed(true); // Mark as failed
      setJsonLoaded(true);
    }
  }

  async function fetchDATESTAMP(env, distribution) {
    try {
      const response = await fetchWithRetry(
        distribution + '/' + env + '/status/datestamp.json',
        fetchReq,
        3,
        1000
      );
      const dateStampData = await response.json();
      setDateStamp(dateStampData);
      setTimestampFetchFailed(false);
    } catch (error) {
      console.error('Error fetching datestamp:', error);
      setTimestampFetchFailed(true);
    }
  }

  // Determine status based on error details
  const determineStatus = (errorDetails) => {
    if (!errorDetails) return 'Operational';
    if (errorDetails === 'Response time threshold exceeded') return 'Degraded Experience';
    return 'Service Disruption';
  };

  // Status color mapping
  const getStatusColor = (status) => {
    switch (status) {
      case 'Operational':
        return green;
      case 'Service Disruption':
        return red;
      case 'Degraded Experience':
        return orange;
      default:
        return green;
    }
  };
  // Get impact message based on error details
  const getImpactMessage = (errorDetails) => {
    if (!errorDetails) return 'No known issues';
    if (errorDetails === 'Response time threshold exceeded') return 'Service is experiencing slowness';
    return 'Service is currently unavailable';
  };


  // Get status icon for main heading
  const getStatusIcon = (status) => {
    if (status === 'Service Disruption') {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill={red} class="bi bi-x-circle" viewBox="0 0 16 16">
          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      );
    }
    if (status === 'Degraded Experience') {
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill={orange} class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
          <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
          <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
        </svg>
      );
    }
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill={green} class="bi bi-check-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
      </svg>
    );
  };

  const loadStatusData = (currentData) => {
    if (!currentData || !currentData.regions) {
      return {
        status: "All Services Operational",
        timestamp: new Date().toISOString(),
        categories: []
      };
    }

    let overallStatus = "All Services Operational";

    currentData.regions.forEach(region => {
      region.components.forEach(component => {
        const componentStatus = determineStatus(component.errorDetails);
        if (componentStatus === "Service Disruption") {
          overallStatus = "Service Disruption";
        } else if (componentStatus === "Degraded Experience" && overallStatus !== "Service Disruption") {
          overallStatus = "Degraded Experience";
        }
      });
    });

    return {
      status: overallStatus,
      timestamp: currentData.timestamp,
      categories: currentData.regions.map(region => {
        let regionStatus = "Operational";
        let regionColor = green;

        region.components.forEach(component => {
          const componentStatus = determineStatus(component.errorDetails);

          if (componentStatus === "Service Disruption") {
            regionStatus = "Service Disruption";
            regionColor = red;
          } else if (componentStatus === "Degraded Experience" && regionStatus !== "Service Disruption") {
            regionStatus = "Degraded Experience";
            regionColor = orange;
          }
        });

        return {
          category: region.name,
          status: regionStatus,
          statusColor: regionColor,
          products: region.components.map(component => {
            const componentStatus = determineStatus(component.errorDetails);
            const componentColor = getStatusColor(componentStatus);
            const impactMessage = getImpactMessage(component.errorDetails);

            return {
              service: component.name,
              impact: impactMessage,
              eventType: componentStatus,
              statusColor: componentColor
            };
          })
        };
      })
    };
  };

  const calculateOngoingDuration = (startTime) => {
    const startDate = new Date(startTime.replace(' ', 'T') + 'Z');
    const now = new Date();

    const diffMillis = now - startDate;
    const totalMinutes = Math.floor(diffMillis / 60000);

    if (totalMinutes < 60) {
      return `${totalMinutes} minutes`;
    }

    const hrs = Math.floor(totalMinutes / 60);
    const mins = totalMinutes % 60;

    if (mins === 0) {
      return `${hrs} hour${hrs > 1 ? 's' : ''}`;
    }

    return `${hrs} hour${hrs > 1 ? 's' : ''} ${mins} minutes`;
  };

  const generateH5PHistory = (data) => {
    if (!data || !data.incidents) {
      return [];
    }

    const processedIncidents = data.incidents.map((incident, idx) => {
      const isOngoing = !incident.endTime;
      const durationText = isOngoing
        ? calculateOngoingDuration(incident.startTime)
        : `${incident.duration} minutes`;

      return {
        uniqueKey: `${incident.startTime}_${incident.affectedRegion}_${incident.affectedComponent}_${idx}`,
        impact: isOngoing ? "Ongoing" : "Resolved",
        impactColor: isOngoing ? red : '#046b23',
        startTime: incident.startTime,
        endTime: incident.endTime || "Ongoing",
        duration: durationText,
        affectedRegion: incident.affectedRegion,
        affectedComponent: incident.affectedComponent
      };
    });

    return processedIncidents.sort((a, b) => {
      if (a.impact === "Ongoing" && b.impact !== "Ongoing") return -1;
      if (a.impact !== "Ongoing" && b.impact === "Ongoing") return 1;
      return new Date(b.startTime) - new Date(a.startTime);
    });
  };

  const help = () => {
    helpDialog.current.opened = true;
  }

  function reloadPage() {
    window.location = "/h5p-status";
  }

  const toggleHistory = () => {
    setShowHistory(!showHistory);
  }


  function darkModeSCSS(bool) {
    if (!nav.current) {
      console.log("Nav element not available, skipping dark mode CSS");
      return;
    }
    if (bool) {
      document.documentElement.style.setProperty('--d2l-dropdown-background-color', '#212121');
      nav.current.style.background = 'rgba(26, 26, 26, 1)';
      nav.current.style.color = 'white';

      document.documentElement.style.setProperty('--bg-color', '#212121');
      document.documentElement.style.setProperty('--accordion-color', '#212121');
      document.documentElement.style.setProperty('--lastUpdated-color', 'white');
      document.documentElement.style.setProperty('--lvl2-color', 'rgba(26, 26, 26, 1)');
      document.documentElement.style.setProperty('--nav-bg-color', 'rgba(26, 26, 26, 1)');
      document.documentElement.style.setProperty('--navbar-brand', green);
      document.documentElement.style.setProperty('--service-name-color', 'white');
      document.documentElement.style.setProperty('--acordion-expanded-color', 'rgba(38, 37, 37, 1)');
      document.documentElement.style.setProperty('--accordion-button-hover', 'rgba(38, 37, 37, 1)');
      document.documentElement.style.setProperty('--font-color', 'white');
      document.documentElement.style.setProperty('--history-list-group', 'rgba(26, 26, 26, 1)');
      document.documentElement.style.setProperty('--main-status-color', 'white');
      document.documentElement.style.setProperty('--accordion-box-shadow', '0px 0px 50px 1px rgba(0, 0, 0, 0.5)');
    }
    else {

      document.documentElement.style.setProperty('--d2l-dropdown-background-color', '#212121');
      nav.current.style.background = 'white';
      nav.current.style.color = 'black';

      document.documentElement.style.setProperty('--bg-color', 'white');
      document.documentElement.style.setProperty('--accordion-color', '#ebebeb');
      document.documentElement.style.setProperty('--lastUpdated-color', 'black');
      document.documentElement.style.setProperty('--navbar-brand', 'white');
      document.documentElement.style.setProperty('--nav-bg-color', 'white');
      document.documentElement.style.setProperty('--accordion-box-shadow', '0px 0px 50px 1px rgba(1, 0, 0,.2)');
      document.documentElement.style.setProperty('--service-name-color', 'black');
      document.documentElement.style.setProperty('--acordion-expanded-color', 'white');
      document.documentElement.style.setProperty('--accordion-button-hover', '#C0C0C0');
      document.documentElement.style.setProperty('--font-color', 'black');
      document.documentElement.style.setProperty('--history-list-group', '#f6f6f6');
      document.documentElement.style.setProperty('--main-status-color', 'black');
    }
  }

  const triggerAutoRefresh = () => {
    if (autoRefresh) {
      autoRefreshSwitch.current.on = false;
      setCookie('AutoRefresh', false, { path: '/' });
      clearInterval(fetchInterval.current);
      setAutoRefresh(false);
    }
    else {
      autoRefreshSwitch.current.on = true;
      setCookie('AutoRefresh', true, { path: '/' });
      fetchInterval.current = setInterval(() => fetchData(), updateInterval);
      setAutoRefresh(true);
    }
  }

  function triggerDarkMode() {
    if (darkMode) {
      darkModeSwitch.current.on = false;
      setDarkMode(false);
      darkModeSCSS(false);
      setCookie('DarkMode', false, { path: '/' });
    }
    else {
      darkModeSwitch.current.on = true;
      setDarkMode(true);
      darkModeSCSS(true);
      setCookie('DarkMode', true, { path: '/' });
    }
  }

  async function fetchData() {
    try {
      await fetchH5PStatusJSON(env, westdistribution);
      await fetchDATESTAMP(env, westdistribution);
      await fetchH5PHistoryJSON(env, westdistribution);
    }
    catch (err) {
      console.log("Error fetching H5P data: " + err);
    }
  }

  function loadSettings() {
    if (cookies.DarkMode == 'true') {
      setDarkMode(true);
      if (darkModeSwitch.current) {
        darkModeSwitch.current.on = true;
      }
      darkModeSCSS(true);
    }
    else if (cookies.DarkMode == null) {
      setDarkMode(false);
      if (darkModeSwitch.current) {
        darkModeSwitch.current.on = false;
      }
      darkModeSCSS(false);
      setCookie('DarkMode', false, { path: '/' });
    }
    else if (cookies.DarkMode == 'false') {
      setDarkMode(false);
      if (darkModeSwitch.current) {
        darkModeSwitch.current.on = false;
      }
      darkModeSCSS(false);
    }

    if (cookies.AutoRefresh == 'true') {
      if (autoRefreshSwitch.current) {
        autoRefreshSwitch.current.on = true;
      }
      setAutoRefresh(true);
      fetchInterval.current = setInterval(() => fetchData(), updateInterval);
    }
    else if (cookies.AutoRefresh == null) {
      if (autoRefreshSwitch.current) {
        autoRefreshSwitch.current.on = false;
      }
      setAutoRefresh(false);
      fetchInterval.current = setInterval(() => fetchData(), updateInterval);
      setCookie('AutoRefresh', true, { path: '/' });
    }
    else if (cookies.AutoRefresh == 'false') {
      if (autoRefreshSwitch.current) {
        autoRefreshSwitch.current.on = false;
      }
      setAutoRefresh(false);
      clearInterval(fetchInterval.current);
    }
  }


  const _handleAccordionKeyDown = (index) => (e) => {
    if (e.key === 'Escape') {
      accordions.current[index].focus();
      accordions.current[index].click();
    }
  }
  useEffect(() => {
    const initializeApp = async () => {
      setInterval(function () {
        setCurrentDate(new Date());
      }, 1000);

      try {
        await fetchH5PStatusJSON(env, westdistribution);
        await fetchDATESTAMP(env, westdistribution);
        await fetchH5PHistoryJSON(env, westdistribution);
      } catch (error) {
        console.error('Error initializing app:', error);
      }
    };

    initializeApp();

    return () => {
      clearInterval(fetchInterval.current);
    };
  }, []);

  // Separate useEffect to handle settings when the DOM is ready
  useEffect(() => {
    // Only load settings when we have data and not in errore
    if (serviceStatusData && !fetchError && nav.current) {
      loadSettings();
      if (cookies.DarkMode === 'true') {
        darkModeSCSS(true);
      } else {
        darkModeSCSS(false);
      }
    }
  }, [serviceStatusData, fetchError]);

  if (fetchError) {
    const isDarkMode = cookies.DarkMode === 'true';

    return (
      <div style={{
        position: 'fixed',
        inset: 0,
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: isDarkMode ? '#1a1a1a' : '#f5f7fa',
        padding: '2rem',
        zIndex: 9999
      }}>
        <div style={{
          textAlign: 'center',
          padding: '4rem 2rem',
          backgroundColor: isDarkMode ? '#2d2d2d' : 'white',
          borderRadius: '12px',
          maxWidth: '600px',
          boxShadow: isDarkMode
            ? '0 10px 40px rgba(0, 0, 0, 0.7)'
            : '0 10px 40px rgba(0, 0, 0, 0.12)'
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill={orange} viewBox="0 0 16 16" style={{ marginBottom: '1.5rem' }}>
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <h3 className="d2l-heading-3" style={{
            color: isDarkMode ? '#ffffff' : '#1a1a1a',
            marginBottom: '1rem',
            fontWeight: '600',
            fontSize: '1.8rem'
          }}>
            Unable to Load Service Status
          </h3>
          <p style={{
            color: isDarkMode ? '#b8b8b8' : '#6e6e6e',
            fontSize: '1.1rem',
            lineHeight: '1.6'
          }}>
            Failed to fetch latest status data. We'll try again on the next refresh in {Math.floor(updateInterval / 60000)} minute{updateInterval !== 60000 ? 's' : ''}.
          </p>
        </div>
      </div>
    );
  }
  if (!serviceStatusData) {
    return <div class="d-flex justify-content-center dark-div">
      <div class="spinner-border dark-div" role="status">
      </div>
    </div>;
  }

  var updatedSeconds = Math.floor((currentDate.getTime() - new Date(dateStamp.dateStamp).getTime()) / 1000);

  return (
    <React.Fragment>
      <div class="pageDiv">
        <d2l-labs-navigation ref={nav} style={(serviceStatusData.status === "All Services Operational") ? { '--d2l-branding-primary-color': green } : (serviceStatusData.status === "Degraded Experience") ? { '--d2l-branding-primary-color': orange } : { '--d2l-branding-primary-color': red }}>
          <d2l-labs-navigation-main-header>
            <div slot="left" class="d2l-labs-navigation-header-left">
              <h1 class="d2lServiceStatus d2l-heading-1" onClick={reloadPage} style={{ cursor: 'pointer' }}>H5P Status
                <a href="/" style={{ fontSize: '0.5em', marginLeft: '0.5rem', color: '#46a661', textDecoration: 'none' }}>
                  by D2L
                </a>
              </h1>
            </div>
            <div slot="right" class="d2l-labs-navigation-header-right">
              <div class="firstIconDiv" style={{ height: '100%' }}>
                <d2l-labs-navigation-dropdown-button-icon text='Settings' icon="tier3:gear">
                  {darkModeSwitch.current.on === true ?
                    <d2l-dropdown-content theme="dark" style={{ top: '80px' }}>
                      <d2l-switch ref={autoRefreshSwitch} theme="dark" onClick={triggerAutoRefresh} text="Auto Refresh"></d2l-switch>
                      <br />
                      <d2l-switch ref={darkModeSwitch} theme="dark" onClick={triggerDarkMode} aria-label='Dark Mode; Menu setting 2 of 2' text="Dark Mode"></d2l-switch>
                    </d2l-dropdown-content>
                    : <d2l-dropdown-content style={{ top: '80px' }}>
                      <d2l-switch ref={autoRefreshSwitch} onClick={triggerAutoRefresh} aria-label='Auto Refresh; Menu setting 1 of 2' text="Auto Refresh"></d2l-switch>
                      <br />
                      <d2l-switch ref={darkModeSwitch} onClick={triggerDarkMode} aria-label='Dark Mode; Menu setting 2 of 2' text="Dark Mode"></d2l-switch>
                    </d2l-dropdown-content>
                  }
                </d2l-labs-navigation-dropdown-button-icon>
              </div>

              <d2l-labs-navigation-button-icon onClick={help} text='Help' text-hidden icon="tier3:help"></d2l-labs-navigation-button-icon>
            </div>
          </d2l-labs-navigation-main-header>
        </d2l-labs-navigation>

        <div class="mainDiv">
          <br />
          {(serviceStatusData.status === "All Services Operational") ?
            <h2 class="d2l-heading-2" id="alert-heading" style={(darkModeSwitch.current.on === true) ? { color: 'white', textAlign: 'center' } : { color: 'black', textAlign: 'center' }}>
              {serviceStatusData.status} {getStatusIcon(serviceStatusData.status)}
            </h2>
            : (serviceStatusData.status === "Degraded Experience") ?
              <h2 class="d2l-heading-2" id="alert-heading" style={(darkModeSwitch.current.on === true) ? { color: 'white', textAlign: 'center' } : { color: 'black', textAlign: 'center' }}>
                Degraded Experience {getStatusIcon(serviceStatusData.status)}
              </h2>
              :
              <h2 class="d2l-heading-2" id="alert-heading" style={(darkModeSwitch.current.on === true) ? { color: 'white', textAlign: 'center' } : { color: 'black', textAlign: 'center' }}>
                Service Disruption {getStatusIcon(serviceStatusData.status)}
              </h2>
          }
          {dateStamp.dateStamp && (
            <p class="lastUpdatedP" style={{ textAlign: 'center' }}>
              Last updated {updatedSeconds === 0 ? <span class="updatedTimeSpan">just now.</span> : updatedSeconds === 1 ? <span class="updatedTimeSpan">{updatedSeconds} second ago.</span> : <span class="updatedTimeSpan">{updatedSeconds} seconds ago.</span>}
            </p>
          )}
          <br />
          <div class="row accordionDiv">
            {serviceStatusData.categories.map((category, categoryIndex) => {
              const statusColor = category.statusColor;

              return (
                <Accordion ref={(ref) => accordionitem.current[categoryIndex] = ref} style={{ padding: '0rem 0rem' }} defaultActiveKey="0" key={category.category}>
                  <Accordion.Item eventKey={categoryIndex} key={category.category + 'item'}>
                    <Accordion.Button ref={(ref) => accordions.current[categoryIndex] = ref} aria-label={'category ' + (categoryIndex + 1) + ' of ' + serviceStatusData.categories.length + '; ' + category.category + '; status is ' + category.status} aria-controls="serviceNames" key={category.category + 'header'}>
                      <div class="serviceNames column inline-block" style={{ fontSize: "20px" }}>
                        <span class="serviceName column inline-block" text="test">
                          <div class='dot-div'>
                            <span class='dot' style={{ "--statusColor": statusColor }}></span>
                          </div>
                          {category.category}
                        </span>
                      </div>
                      <div class="serviceStates1 column inline-block">
                        {(category.status === "Operational") ?
                          <d2l-status-indicator state="success" text="Operational" style={{ fontSize: "12px" }}></d2l-status-indicator>
                          : (category.status === "Degraded Experience") ?
                            <d2l-status-indicator state="none" text="Degraded Experience" style={{ fontSize: "12px", color: "orange", borderColor: "orange" }}></d2l-status-indicator>
                            :
                            <d2l-status-indicator state="alert" text="Service Disruption" style={{ fontSize: "12px" }}></d2l-status-indicator>
                        }
                      </div>
                    </Accordion.Button>
                    <Accordion.Body id={category.category}>
                      <div class="status">
                        {category.products.map((product, productIndex) => {
                          const productColor = product.statusColor;

                          return (
                            <Accordion style={{ padding: '0rem 0rem' }} key={productIndex}>
                              <Accordion.Item eventKey={productIndex}>
                                <Accordion.Button aria-label={category.category + ' category; product ' + (productIndex + 1) + ' of ' + category.products.length + '; ' + product.service + '; status is ' + product.eventType} onKeyDown={_handleAccordionKeyDown(categoryIndex)}>
                                  <div class="accordionButtonDiv row inline-block" style={{ "--statusColor": productColor }}>
                                    <div class="serviceNames column inline-block">
                                      <div class='dot-div'>
                                        <span class='dot'></span>
                                      </div>
                                      <span class='serviceName'>{product.service}</span>
                                    </div>
                                    <div class="serviceStates column inline-block">
                                      {(product.eventType === "Operational") ?
                                        <d2l-status-indicator state="success" text="Operational" style={{ fontSize: "12px" }}></d2l-status-indicator>
                                        : (product.eventType === "Degraded Experience") ?
                                          <d2l-status-indicator state="none" text="Degraded Experience" style={{ fontSize: "12px", color: "orange", borderColor: "orange" }}></d2l-status-indicator>
                                          :
                                          <d2l-status-indicator state="alert" text="Service Disruption" style={{ fontSize: "12px" }}></d2l-status-indicator>
                                      }
                                    </div>
                                  </div>
                                </Accordion.Button>
                                <Accordion.Body>
                                  <div class="content">
                                    <p>{product.impact}</p>
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                          );
                        })}
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              );
            })}
          </div>
          <br />
          {/* Toggle History Button */}
          <div class="row accordionDiv" style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
            <d2l-button primary onClick={toggleHistory} style={{ width: 'auto', padding: '0.5rem 1.5rem' }}>
              {showHistory ? 'Hide Past Incidents' : 'Show Past Incidents'}
            </d2l-button>
          </div>

          {/* History Section - Table View or Empty State */}
          {showHistory && (
            <div className="row accordionDiv">
              {historyFetchFailed ? (
                // Show error message when fetch failed
                <div style={{
                  textAlign: 'center',
                  padding: '4rem 2rem',
                  backgroundColor: (darkModeSwitch.current.on === true) ? '#212121' : '#f8f9fa',
                  borderRadius: '8px',
                  border: (darkModeSwitch.current.on === true) ? '1px solid #444' : '1px solid #dee2e6'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill={orange} viewBox="0 0 16 16" style={{ marginBottom: '1.5rem' }}>
                    <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                  </svg>
                  <h3 className="d2l-heading-3" style={{
                    color: (darkModeSwitch.current.on === true) ? 'white' : 'black',
                    marginBottom: '1rem',
                    fontWeight: '600'
                  }}>
                    Unable to Load Incident History
                  </h3>
                  <p style={{
                    color: (darkModeSwitch.current.on === true) ? '#b8b8b8' : '#6e6e6e',
                    fontSize: '1.1rem',
                    maxWidth: '500px',
                    margin: '0 auto',
                    lineHeight: '1.6'
                  }}>
                    Failed to fetch incident history. We'll try again on the next refresh in {Math.floor(updateInterval / 60000)} minute{updateInterval !== 60000 ? 's' : ''}.
                  </p>
                </div>
              ) : !incidentHistory ? (
                // Show loading spinner while data is being fetched
                <div className="d-flex justify-content-center" style={{ padding: '4rem 2rem' }}>
                  <div className="spinner-border" role="status" style={{ color: (darkModeSwitch.current.on === true) ? '#ffffff' : '#000000' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : incidentHistory.length > 0 ? (
                // Show table when we have incidents
                <div className="table-responsive" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                  <table className="table table-bordered" style={(darkModeSwitch.current.on === true) ? { color: 'white', backgroundColor: '#212121', borderColor: '#444' } : { color: 'black', backgroundColor: 'white', borderColor: '#dee2e6' }}>
                    <thead style={(darkModeSwitch.current.on === true) ? { backgroundColor: '#212121', borderColor: '#444', position: 'sticky', top: 0, zIndex: 1, borderTop: '1px solid #444' } : { backgroundColor: '#f8f9fa', borderColor: '#dee2e6', position: 'sticky', top: 0, zIndex: 1, borderTop: '1px solid #dee2e6' }}>
                      <tr>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa' }}>Region</th>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa' }}>Component</th>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121', minWidth: '180px', whiteSpace: 'nowrap' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa', minWidth: '180px', whiteSpace: 'nowrap' }}>Start Time (UTC)</th>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121', minWidth: '180px', whiteSpace: 'nowrap' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa', minWidth: '180px', whiteSpace: 'nowrap' }}>End Time (UTC)</th>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa' }}>Duration</th>
                        <th style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', color: '#4a9eff', backgroundColor: '#212121' } : { borderColor: '#dee2e6', color: 'black', backgroundColor: '#f8f9fa' }}>Status</th>
                      </tr>
                    </thead>

                    <tbody>
                      {incidentHistory.map((incident) => (
                        <tr key={incident.uniqueKey} style={(darkModeSwitch.current.on === true) ? { backgroundColor: '#212121', borderColor: '#444' } : { backgroundColor: 'white', borderColor: '#dee2e6' }}>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>{incident.affectedRegion}</td>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>{incident.affectedComponent}</td>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>{incident.startTime}</td>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>{incident.endTime}</td>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>{incident.duration}</td>
                          <td style={(darkModeSwitch.current.on === true) ? { borderColor: '#444', backgroundColor: '#212121', color: 'white' } : { borderColor: '#dee2e6', backgroundColor: 'white', color: 'black' }}>
                            <span style={{ color: 'white', backgroundColor: incident.impactColor, padding: '0.2rem 0.5rem', borderRadius: '4px' }}>
                              {incident.impact}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                // Show success message when we successfully fetched but got empty array (incidentHistory.length === 0)
                <div style={{
                  textAlign: 'center',
                  padding: '4rem 2rem',
                  backgroundColor: (darkModeSwitch.current.on === true) ? '#212121' : '#f8f9fa',
                  borderRadius: '8px',
                  border: (darkModeSwitch.current.on === true) ? '1px solid #444' : '1px solid #dee2e6'
                }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill={green} viewBox="0 0 16 16" style={{ marginBottom: '1.5rem' }}>
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                  </svg>
                  <h3 className="d2l-heading-3" style={{
                    color: (darkModeSwitch.current.on === true) ? 'white' : 'black',
                    marginBottom: '1rem',
                    fontWeight: '600'
                  }}>
                    No Incidents in the Last 90 Days
                  </h3>
                  <p style={{
                    color: (darkModeSwitch.current.on === true) ? '#b8b8b8' : '#6e6e6e',
                    fontSize: '1.1rem',
                    maxWidth: '500px',
                    margin: '0 auto',
                    lineHeight: '1.6'
                  }}>
                    Great news! All H5P services have been operating smoothly with no recorded incidents in the past 90 days.
                  </p>
                </div>
              )}
            </div>
          )}
          <br />
        </div>

        <d2l-dialog ref={helpDialog} id="helpDialog" title-text="H5P Service Status Page Help">
          <div>
            <p tabIndex="0">Welcome to the H5P Service Status Page. The purpose of this page is to provide our clients and end users with up to date operational status of H5P services across different regions.</p>
            <p>Our services are divided into 4 regions: United States, Europe, Canada, and Australia. You may click on each region to view its associated components and the respective status.</p>
            <p>There are 3 different types of statuses: "Operational" indicates that the service is running without any known issues. "Service Disruption" means the service is unavailable. "Degraded Experience" indicates that the service is operational but experiencing issues that may impact performance.</p>
          </div>
          <d2l-button slot="footer" data-dialog-action>Close</d2l-button>
        </d2l-dialog>

        <div class="pageDivbottom">
          {(darkModeSwitch.current.on !== true) ?
            <a class="element1" style={{ fontSize: '1.5rem', color: 'black' }} href="https://www.d2l.com/security/" target="_blank" rel="noopener noreferrer">Security</a>
            : (darkModeSwitch.current.on === true) ?
              <a class="element1" style={{ fontSize: '1.5rem', color: 'white' }} href="https://www.d2l.com/security/" target="_blank" rel="noopener noreferrer">Security</a>
              : null}
          {(darkModeSwitch.current.on !== true) ?
            <a class="element2" style={{ fontSize: '1.5rem', color: 'black' }} href="https://www.d2l.com/cloud/" target="_blank" rel="noopener noreferrer">Cloud</a>
            : (darkModeSwitch.current.on === true) ?
              <a class="element2" style={{ fontSize: '1.5rem', color: 'white' }} href="https://www.d2l.com/cloud/" target="_blank" rel="noopener noreferrer">Cloud</a>
              : null}
        </div>
      </div>
    </React.Fragment>
  );
}